import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {ProductFace as Entity} from "./product-face.model";
import {IPageInfo, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";


export interface ProductFaceState extends EntityState<Entity> {
  entities: { [id: number]: Entity };
  entitiesTemporary: Entity[];
  ids: number[];
  isLoading: boolean;
  error: Error | undefined;
  currentPage: IPageInfo;
  currentSort: ITableSort | undefined;
  currentEntityId: number | undefined,
  currentTemporaryId: number | undefined,
  history: { correlationId: string, payload: Entity | Entity[] | number | number[] | IResultWithPageInfo<Entity> }[];
}

export const productFaceEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>(
  {
    selectId: (product: Entity) => product.id
  }
);

export const initialState: ProductFaceState = productFaceEntityAdapter.getInitialState({
  entities: [],
  entitiesTemporary: [],
  ids: [],
  isLoading: false,
  error: undefined,
  currentPage: { page: { pageNumber: 0, pageSize: 25 }, totalCount: 0},
  currentSort: undefined,
  currentEntityId: undefined,
  currentTemporaryId: undefined,
  history: []
});
